import { FORMAS_PAGO } from "../../lib/api";

// Cómo se pagó: efectivo, tarjeta, SINPE o transferencia.
// Solo aparece donde entra plata: ventas de contado y abonos. En una
// venta a crédito no se paga nada todavía, así que no se muestra.
const SelectorFormaPago = ({ valor, onChange }) => (
  <div className="form-group">
    <label className="form-label">Forma de pago</label>
    <div className="formas-pago">
      {FORMAS_PAGO.map((forma) => (
        <button
          key={forma.valor}
          type="button"
          className="forma-pago"
          aria-pressed={valor === forma.valor}
          onClick={() => onChange(forma.valor)}
        >
          {forma.nombre}
        </button>
      ))}
    </div>
  </div>
);

export default SelectorFormaPago;
